export default "__VITE_ASSET__BcYbKZWo__"